export function initializeExternalRedirect() {
    $(document).on('click', 'a', function (e) {
        let host = window.location.hostname;
        let href = $(this).attr('href');
        let isGallery = $(this).hasClass('lg-download');

        if (!isGallery && isValidHttpUrl(href) && typeof href !== "undefined" && !href.startsWith('#') && !href.startsWith('javascript') && !href.startsWith('mailto:') && !href.startsWith('tel:')) {
            if (!href.includes(host) && $(this).hasClass('ignore') === false) {
                e.preventDefault();

                let target = $(this).attr('target');
                window.open('https://' + host + '/redirect?url=' + href, target ? target : '_self');
            }
        }
    });
}


export function initializeExternalAdminRedirect() {
    $(document).on('click', 'a', function (e) {
        let host = window.location.hostname;
        let href = $(this).attr('href');

        if (isValidHttpUrl(href) && typeof href !== "undefined" && !href.startsWith('#') && !href.startsWith('javascript') && !href.startsWith('mailto:') && !href.startsWith('tel:')) {
            if (!href.includes(host) && $(this).hasClass('ignore') === false) {
                e.preventDefault();
                window.open('https://' + host + '/redirect?url=' + href, '_blank');
            }
        }
    });

    if (document.getElementById('support-iframe') !== null) {
        document.getElementById('support-iframe').onload = function () {
            let frame = $('#support-iframe').contents();

            frame.find('a').on('click', function (e) {
                e.preventDefault();
                window.open('https://' + window.location.hostname + '/redirect?url=' + $(this).attr('href'), '_blank');
            });
        };
    }
}

function isValidHttpUrl(string) {
    let url;

    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }

    return url.protocol === "http:" || url.protocol === "https:";
}
